import eventBus from 'Lib/eventBus';
import { Utils } from 'vue-graphql-models';

export default {
  mounted() {
    eventBus.$on('menuClick', ({ item, event }) => {
      const itemHandler = `$menuClick${Utils.ucwords(item.id)}`;

      // istanbul ignore else
      if (typeof this.$menuClick !== 'undefined') {
        this.$menuClick({ item, event });
      }

      // istanbul ignore else
      if (typeof this[itemHandler] !== 'undefined') {
        this[itemHandler]({ item, event });
      }
    });
  },
};
